module.exports = __webpack_public_path__ + "static/media/cp.b186e4e1.svg";